import React from 'react';

const AnalyticsPage: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">통계 분석</h1>
      <p className="text-gray-600">통계 분석 페이지가 여기에 표시됩니다.</p>
    </div>
  );
};

export default AnalyticsPage;
